import { useNavigate } from '@tanstack/react-router';
import { HugeiconsIcon, IconSvgElement } from '@hugeicons/react';

function NavButton({ label, selected, collapsed, icon, path, onClick }: {
  label: string,
  selected: boolean,
  collapsed: boolean,
  icon?: IconSvgElement,
  path: string,
  onClick?: () => void
}) {

  const navigate = useNavigate();

  const activeClass = selected ? 'bg-slate-100 text-black' : 'hover:bg-slate-100 text-slate-700';
  const collapsedClass = collapsed ? 'justify-center' : 'justify-start';

  return (
    <div onClick={() => onClick ? onClick() : navigate({ to: path })}
         className={`w-full h-[32px] rounded-md flex items-center gap-1 px-2 cursor-pointer font ${activeClass} mb-1 ${collapsedClass}`}
    >
      {icon &&
        <div className={`flex items-center justify-center p-0.5 rounded-md`}>
          <HugeiconsIcon
            icon={icon}
            size={18}
            color="currentColor"
            strokeWidth={2}

          />
        </div>
      }
      {collapsed ? null : <p style={{ fontSize: 14, marginLeft: 4 }}>{label}</p>}
    </div>
  );
}

export default NavButton;
